import * as yup from 'yup'
import { REMEDY_PRICE } from '../../constants';

export let Schema = {
  businessName: {
    'Business Name': { value: '', field: 'name', validation: yup.string().required() }
  },
  discount: {
    'Discount': { type: 'number', value: '', placeholder: '0%', field: 'discount', validation: yup.number().integer().min(0).max(99).optional() }
  },
  companyNumber: {
    'Company Number': { value: '', field: 'companyNumber', validation: yup.string() }
  },
  businessAddress: {
    'Postcode': { value: '', field: 'address.postcode', validation: yup.string().required() },
    'Address Line 1': { value: '', field: 'address.name', validation: yup.string().required() },
    'Address Line 2': { value: '', field: 'address.street', validation: yup.string() },
    'City': { value: '', field: 'address.city', validation: yup.string().required() },
    'Country': { value: '', field: 'address.country', validation: yup.string().required() }
  },
  adminDetails: {
    'First Name': { value: '', field: 'primaryUser.firstName', validation: yup.string().required() },
    'Last Name': { value: '', field: 'primaryUser.lastName', validation: yup.string().required() },
    'Position': { value: '', field: 'primaryUser.position', validation: yup.string().required() },
    'E-mail Address': { value: '', field: 'primaryUser.email', validation: yup.string().email().required() },
    'Contact Number': { value: '', field: 'primaryUser.telephone', validation: yup.string().required() }
  },
  contractTermsLeft: {
    'Number of Sites': { type: 'number', value: '', field: 'currentContract.slots', validation: yup.number().integer().min(0).required() },
    'Transaction fee': {
      value: 0,
      type: 'number',
      field: 'commissions.transaction_fee',
      validation: yup.number().min(0).max(REMEDY_PRICE).required()
    },
    'Commission cost - delivery': {
      value: 0,
      type: 'number',
      field: 'commissions.delivery',
      validation: yup.number().min(0).max(REMEDY_PRICE).required()
    },
    'Contract Length (in months)': { type: 'select', values: ['', 6, 12, 18, 24], field: 'currentContract.count', validation: yup.string().required() },
    'Commission cost - E-Commerce %': {
      value: 0,
      type: 'number',
      field: 'commissions.otc_commission',
      validation: yup.number().min(0).max(100).required(),
    },
  },
  contractTermsRight: {
    'Contract Start Date': { type: 'date', value: '', field: 'currentContract.startDate', validation: yup.date().required() },
    'Transaction fee %': {
      value: 0,
      type: 'number',
      field: 'commissions.transaction_fee_percentage',
      validation: yup.number().min(0).max(100).required()
    },
    'Commission cost - collection': {
      value: 0,
      type: 'number',
      field: 'commissions.collect',
      validation: yup.number().min(0).max(REMEDY_PRICE).required()
    },
    'Trial Period (in months)': { type: 'select', values: [0, 1, 2, 3, 4], field: 'currentContract.trialPeriod', validation: yup.number().optional() },
    'Trial Period Charge (in GBP)': { type: 'select', values: ['', 5, 10, 20, 30, 40, 50], field: 'currentContract.trialPeriodCharge', validation: yup.number().required() }
  },
  customPrice: {
    'Custom Price': { value: '0.0', field: 'currentContract.unitPrice', validation: yup.number().truncate(2).required() },
  }
}
